"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@chakra-ui/react");
var _FaSearchMinus = require("@react-icons/all-files/fa/FaSearchMinus");
var _FaSearchPlus = require("@react-icons/all-files/fa/FaSearchPlus");
var _react2 = require("react");
var _reactZoomPanPinch = require("react-zoom-pan-pinch");
var _SnekStudio = _interopRequireDefault(require("../../molecules/SnekStudio"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ImageViewer = props => {
  const bg = (0, _react.useColorModeValue)('white', 'gray.600');
  const borderColor = (0, _react.useColorModeValue)('gray.100', '#FFFFFF14');
  const [isSnekStudioOpen, setIsSnekStudioOpen] = (0, _react2.useState)(false);
  const handleOpenSnekStudio = () => {
    setIsSnekStudioOpen(true);
  };
  const handleCloseSnekStudio = () => {
    setIsSnekStudioOpen(false);
  };
  const [scale, setScale] = (0, _react2.useState)(1);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Portal, {
    appendToParentPortal: false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Box, {
      pos: "fixed",
      top: 0,
      w: "100%",
      h: "100vh",
      zIndex: "10",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactZoomPanPinch.TransformWrapper, {
        initialScale: scale,
        doubleClick: {
          disabled: true
        },
        onZoom: ref => {
          setScale(ref.state.scale);
        },
        minScale: 0.5,
        maxScale: 8,
        children: ({
          zoomIn,
          zoomOut,
          resetTransform,
          ...rest
        }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
            direction: "column",
            overflow: "hidden",
            left: 0,
            top: 0,
            h: "100%",
            w: "100%",
            pos: "absolute",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.HStack, {
              borderBottom: "solid 1px",
              bg: bg,
              borderColor: borderColor,
              pb: 3,
              pt: 3,
              pr: 2,
              h: '7.5vh',
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
                width: "100%",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Spacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.HStack, {
                  children: [!isSnekStudioOpen && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
                      onClick: handleOpenSnekStudio,
                      children: "Snek Studio"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {
                      orientation: "vertical"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Text, {
                      fontSize: "xs",
                      minW: 35,
                      textAlign: "center",
                      userSelect: "none",
                      children: [Math.round(scale * 100), "%"]
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
                      "aria-label": "a",
                      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaSearchPlus.FaSearchPlus, {}),
                      opacity: scale === 8 ? 0.5 : 1
                      // onClick={() => onSetScale(1)}
                      ,
                      onClick: () => {
                        zoomIn();
                        if (scale + 0.2 > 8) {
                          setScale(8);
                        } else {
                          setScale(scale + 0.2);
                        }
                      }
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
                      "aria-label": "a",
                      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaSearchMinus.FaSearchMinus, {}),
                      opacity: scale === 0.5 ? 0.5 : 1
                      // onClick={() => onSetScale(0)}
                      ,
                      onClick: () => {
                        zoomOut();
                        if (scale - 0.2 < 0.5) {
                          setScale(0.5);
                        } else {
                          setScale(scale - 0.2);
                        }
                      }
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.CloseButton, {
                    onClick: props.onClose
                  })]
                })]
              })
            }), isSnekStudioOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnekStudio.default, {
              src: props.src,
              name: props.name,
              isOpen: isSnekStudioOpen,
              onComplete: props.onUpdate,
              shouldClose: handleCloseSnekStudio
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Center, {
              bg: "rgba(0,0,0,0.6)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactZoomPanPinch.TransformComponent, {
                contentStyle: {
                  height: '100vh'
                },
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Image, {
                  src: props.src,
                  h: "100%"
                })
              })
            })]
          })
        })
      })
    })
  });
};
var _default = ImageViewer;
exports.default = _default;